export default __webpack_public_path__ + "static/media/envelope-solid.a9a8c84a.svg";